module.exports = __webpack_public_path__ + "static/media/ICONS-AUTOMATION.2d554901.svg";